import { mapGetters } from 'vuex';
export default {
  name: "RegistrationButtonComponent",
  computed: mapGetters(['can'])
};